import React, { useState } from 'react';

import SlideOver from '../procurement/face/SlideOver';

import Button from 'CommonComponents/Button';
import TextButton from 'CommonComponents/TextButton';

/**
 * The side panel for a column note or a line note: Save, Remove (when one exists) and
 * Cancel. Read-only for members who cannot edit the report.
 */
export default function NotePanel({ target, reportTitle, canEdit, onSave, onClose }) {
    const [text, setText] = useState(target?.note ?? '');
    const [saving, setSaving] = useState(false);

    if (!target) {
        return null;
    }

    const isColumn = target.kind === 'column';
    const hasNote = !!target.note;

    const save = async (note) => {
        setSaving(true);

        try {
            await onSave(note);
        } catch {
            setSaving(false);
        }
    };

    return (
        <SlideOver
            isOpen
            onClose={onClose}
            title={isColumn ? $t('Column note') : $t('Line note')}
            subtitle={
                isColumn
                    ? $t('Column {{name}} · {{report}} report', { name: target.label, report: reportTitle })
                    : $t('{{path}} · {{report}} report', { path: target.label, report: reportTitle })
            }
        >
            <div className="tw-flex tw-h-full tw-flex-col tw-gap-y-3">
                <textarea
                    className="text-input tw-min-h-[180px] tw-leading-relaxed"
                    value={text}
                    autoFocus={canEdit}
                    readOnly={!canEdit}
                    maxLength={5000}
                    onChange={(event) => setText(event.target.value)}
                    placeholder={
                        isColumn
                            ? $t('What this column represents, the agreement or basis behind it, any cap or condition.')
                            : $t('Why this line is allocated this way, what is still to be confirmed, who agreed it.')
                    }
                />
                <div className="tw-text-xs tw-text-charcoal-50">{$t('Notes are included in the file export.')}</div>
                {canEdit && (
                    <div className="tw-mt-auto tw-flex tw-items-center tw-gap-x-1.5">
                        {hasNote && (
                            <TextButton className="!tw-normal-case" variant="danger" onClick={() => save(null)} disabled={saving}>
                                {$t('Remove note')}
                            </TextButton>
                        )}
                        <Button className="tw-ms-auto" variant="secondary" onClick={onClose} disabled={saving}>
                            {$t('Cancel')}
                        </Button>
                        <Button variant="primary" onClick={() => save(text.trim() || null)} disabled={saving} loading={saving}>
                            {$t('Save note')}
                        </Button>
                    </div>
                )}
            </div>
        </SlideOver>
    );
}
